import React from 'react';
import { cn, formatNumber } from '../../lib/utils';

const funnelStages = [
    { key: 'reach', label: 'Reach', color: '#FF3B30' },
    { key: 'connect', label: 'Connect', color: '#D63025' },
    { key: 'nurture', label: 'Nurture', color: '#B52A20' },
    { key: 'response', label: 'Response', color: '#0077B5' },
    { key: 'future_leads', label: 'Future Leads', color: '#F59E0B' },
    { key: 'positive_response', label: 'Positive Response', color: '#34A853' },
    { key: 'mql', label: 'MQL', color: '#10B981' },
    { key: 'sql', label: 'SQL', color: '#059669' },
];

export const FunnelVisualization = ({ data, className }) => {
    const maxValue = Math.max(...Object.values(data || {}), 1);

    return (
        <div className={cn('card-base p-6', className)} data-testid="funnel-visualization">
            <h3 className="text-lg font-heading font-bold text-white mb-6">
                ABM FUNNEL
            </h3>
            <div className="space-y-3">
                {funnelStages.map((stage, index) => {
                    const value = data?.[stage.key] || 0;
                    const width = (value / maxValue) * 100;
                    const prevValue = index > 0 ? data?.[funnelStages[index - 1].key] || 0 : 0;
                    const conversionRate = prevValue > 0 ? ((value / prevValue) * 100).toFixed(1) : null;

                    return (
                        <div 
                            key={stage.key} 
                            className="funnel-stage"
                            data-testid={`funnel-stage-${stage.key}`}
                        >
                            <div className="flex items-center justify-between mb-1">
                                <span className="text-sm text-content-secondary">
                                    {stage.label}
                                </span>
                                <div className="flex items-center gap-3">
                                    <span className="text-sm font-bold text-white">
                                        {formatNumber(value)}
                                    </span>
                                    {conversionRate && (
                                        <span className="text-xs text-content-muted">
                                            ({conversionRate}%)
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="h-8 bg-surface-app rounded-md overflow-hidden relative">
                                <div
                                    className="h-full rounded-md transition-all duration-500 ease-out flex items-center justify-end pr-3"
                                    style={{
                                        width: `${Math.max(width, 5)}%`,
                                        backgroundColor: stage.color,
                                    }}
                                >
                                    {width > 20 && (
                                        <span className="text-xs font-bold text-white/80">
                                            {formatNumber(value)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Funnel legend */}
            <div className="mt-6 pt-4 border-t border-line-default">
                <div className="grid grid-cols-4 gap-2 text-xs">
                    {funnelStages.slice(0, 4).map((stage) => (
                        <div key={stage.key} className="flex items-center gap-2">
                            <div 
                                className="w-3 h-3 rounded-sm"
                                style={{ backgroundColor: stage.color }}
                            />
                            <span className="text-content-muted">{stage.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FunnelVisualization;
